// Chakra imports
import {
  Heading,
  Box,
  SimpleGrid,
  Text,
  HStack,
  VStack,
  Icon,
  Button,
  Card,
  Flex,
  useColorModeValue,
  useOutsideClick,
  Select,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from "@chakra-ui/react";

import "./analytics.css";

import { RadialChart } from "react-vis";
import { FiSunrise, FiSunset, FiPhoneOff, FiCalendar } from "react-icons/fi";

import AnalyticsTable from "views/admin/niclAnalytics/components/AnalyticsTable";
import { DatePicker } from "antd"; // Import Ant Design DatePicker
import { DownloadIcon } from "@chakra-ui/icons";

import UnAnswereAnalyticsTable from "views/admin/dataTables/components/UnAnswereAnalyticsTable";
import {
  MorningCallTableColumns,
  EveningCallTableColumns,
  UnansweredCallTableColumns,
  INCCallTableColumns,
  IPACCallTableColumns,
  NICLAnalyticsColumn,
  wfNameAndIdmapping,
} from "views/admin/niclAnalytics/variables/columnsData";
import tableDataDev from "views/admin/niclAnalytics/variables/tableDataDevelopment.json";

import { React, useEffect, useState, useRef } from "react";
import Chart from "react-apexcharts";
import { downloadExcel } from "react-export-table-to-excel";
import { useSelector, useDispatch } from "react-redux";
import { setLoader } from "../../../redux/actions/loader";
import {
  getAnalyticsDataAction,
  getAnalyticsCallBreakDownDataAction,
  getAnalyticsDataEveningAction,
  putEditAnalyticsDataAction,
  getAnalyticsDataActionINC,
  getAnalyticsCallBreakDownDataActionINC,
} from "../../../redux/actions/analytics";
import * as type from "../../../redux/types";
import {
  removeUnderscore,
  ROLE_ACCESS,
  removeUnderscoreIPAC,
} from "utils/Utils";
import moment from "moment";
import PolicyRenewalDashboard from "./workflowViews/PolicyRenewalDashboard";
import HealthInsuranceDashboard from "./workflowViews/HealthInsuranceDashboard";
import PolicyPDFDownloadDashboard from "./workflowViews/PolicyPDFDownloadDashboard";
import MobileNumberRegistrationDashboard from "./workflowViews/MobileNumberRegistrationDashboard";
import DebtCollectionDashboard from "./workflowViews/DebtCollectionDashboard";
import ZetScenario3Dashboard from "./workflowViews/ZetScenarioId3";
import ZetScenario4Dashboard from "./workflowViews/ZetScenarioId4";
import ZetScenario5Dashboard from "./workflowViews/ZetScenarioId5";
import ZetScenario6Dashboard from "./workflowViews/ZetScenarioId6";
import ZetScenario7Dashboard from "./workflowViews/ZetScenarioId7";
import ZetScenario32Dashboard from "./workflowViews/ZetScenarioId32";
const UTC_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";

export default function Settings() {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const calenderRef = useRef();

  const analyticsData = useSelector(
    (state) => state.analyticsData.analyticsCallTableData,
  );

  const analyticsDataEVN = useSelector(
    (state) => state.analyticsData.analyticsCallDataEvening,
  );
  const [wfSelection, setWfSelection] = useState(wfNameAndIdmapping[0]);
  const [dndNumberData, setDnDNumberData] = useState([]);
  const userData = useSelector((state) => state.userData);
  const analyticsAll = useSelector((state) => state.analyticsData);
  const [modalAllcallBreakdownData, setModalCallBreakdownData] =
    useState(false);
  // console.log("Analytics data",analyticsAll)
  // console.log("User data",userData)
  //const chartColorArr =["#0079EA","#7EBAF3","#E4F0FB","#E4F0FB","#E4F0FB","#E4F0FB"]
  //green, red, yellow, other
  const chartColorArr = [
    "#47B39C",
    "#EC6B56",
    "#FFC154",
    "#0079EA",
    "#FE0175",
    "#800080",
    "#3cdfff",
    "#E4F0FB",
  ];

  useOutsideClick({
    ref: calenderRef,
    handler: () => {
      setSelectedButton((state) => {
        return { ...state, isCustom: false };
      });
    },
  });

  let limit = 25;
  let page = 1;
  let clientName = "Sobisco";
  let scenarioID = "p0001";

  const [selectedButton, setSelectedButton] = useState({
    isToday: false,
    is7days: false,
    is30Days: false,
    isToday: false,
    is7days: false,
    is30Days: false,
    isCustom: false,
  });

  const [selectedDateRange, setSelectedDateRange] = useState({});

  const { RangePicker } = DatePicker;

  const onRangeChange = (dates, dateStrings) => {
    if (dates) {
      setSelectedButton({
        isToday: false,
        is7days: false,
        is30Days: false,
        isCustom: true,
      });
      setSelectedDateRange({
        startDate: moment(dates[0].toDate()).format(UTC_DATE_TIME_FORMAT),
        endDate: moment(dates[1].toDate()).format(UTC_DATE_TIME_FORMAT),
      });
    }
  };

  const updateAnalyticsValue = (edittedValue) => {
    let dataInvoke = prePaireEditApiData(edittedValue);
    //console.log("dataInvoke",dataInvoke);
    dispatch(putEditAnalyticsDataAction(dataInvoke));
  };

  const prePaireEditApiData = (edittedValue) => {
    let returnData = {};

    if (edittedValue.isEvening) {
      returnData = analyticsDataEVN.filter(
        ({ sessionId }) => sessionId === edittedValue.value.sessionId,
      )[0];

      returnData.callAnanlytics.total_number_calls =
        edittedValue.value.value.callsMadeToday;
      returnData.callAnanlytics.total_productive_calls =
        edittedValue.value.value.productiveCalls;
      returnData.callAnanlytics.total_sell_value =
        edittedValue.value.value.sellValueForToday;
      returnData.callAnanlytics.head_office_meeting =
        edittedValue.value.value.officeMeeting;
    } else {
      returnData = analyticsData.filter(
        ({ sessionId }) => sessionId === edittedValue.value.sessionId,
      )[0];

      returnData.callAnanlytics.serving_market =
        edittedValue.value.value.shopsToBeVisited;
      returnData.callAnanlytics.focused_product =
        edittedValue.value.value.focusedProduct;
      returnData.callAnanlytics.total_retail_shop =
        edittedValue.value.value.totalRetailShop;
    }

    delete returnData["_id"];
    delete returnData.userInfo["_id"];
    delete returnData.userInfo["__v"];

    // returnData.callAnanlytics[edittedValue.key] = edittedValue.newValue;

    return returnData;
  };
  const getTodaysData = () => {
    setSelectedButton({
      ...selectedButton,
      isToday: true,
      is7days: false,
      is30Days: false,
      isCustom: false,
    });
    setSelectedDateRange({
      ...selectedDateRange,
      startDate: moment()
        .utc()
        .set({ hours: "0", minutes: "0", seconds: "0" })
        .format(UTC_DATE_TIME_FORMAT),
      // endDate: moment().utc().format(UTC_DATE_TIME_FORMAT),
      endDate: moment()
        .utc()
        .add(5, "hours")
        .add(30, "minutes")
        .format(UTC_DATE_TIME_FORMAT),
    });
  };

  const getSevenDaysData = () => {
    setSelectedButton({
      ...selectedButton,
      is7days: true,
      isToday: false,
      is30Days: false,
      isCustom: false,
    });
    setSelectedDateRange({
      ...selectedDateRange,
      startDate: moment()
        .utc()
        .set({ hours: "0", minutes: "0", seconds: "0" })
        .subtract(6, "days")
        .format(UTC_DATE_TIME_FORMAT),
      // endDate: moment().utc().format(UTC_DATE_TIME_FORMAT),
      endDate: moment()
        .utc()
        .add(5, "hours")
        .add(30, "minutes")
        .format(UTC_DATE_TIME_FORMAT),
    });
  };

  const getThirtyDaysData = () => {
    setSelectedButton({
      ...selectedButton,
      isToday: false,
      is7days: false,
      is30Days: true,
      isCustom: false,
    });
    setSelectedDateRange({
      ...selectedDateRange,
      startDate: moment()
        .utc()
        .set({ hours: "0", minutes: "0", seconds: "0" })
        .subtract(30, "days")
        .format(UTC_DATE_TIME_FORMAT),
      endDate: moment()
        .utc()
        .add(5, "hours")
        .add(30, "minutes")
        .format(UTC_DATE_TIME_FORMAT),
    });
  };

  const invokedGetAnalyticsApiDataCall = () => {
    dispatch(
      getAnalyticsDataAction({
        selectedDateRange,
        clientName,
        scenarioID: "p0001",
        limit,
        page,
        token: userData.token,
      }),
    );
    dispatch(
      getAnalyticsCallBreakDownDataAction({
        selectedDateRange,
        token: userData.token,
      }),
    );
  };

  useEffect(() => {
    getTodaysData();
    // getThirtyDaysData()
  }, []);

  useEffect(() => {
    // console.log("selectedDateRange");
    if (selectedDateRange.startDate && selectedDateRange.endDate) {
      // console.log("selectedDateRange if");
      // invokedGetAnalyticsApiDataCall();
    }
  }, [selectedDateRange]);

  const callBreakDownData = useSelector(
    (state) => state.analyticsData.callBreakDownData.callAnalytics,
  );
  // console.log("Call break down data", callBreakDownData);
  const unansweredCallUserDetails = useSelector((state) =>
    state.analyticsData.callBreakDownData?.unansweredCallUserDetails
      ? state.analyticsData.callBreakDownData?.unansweredCallUserDetails
      : [],
  );
  const textColor = useColorModeValue("secondaryGray.900", "white");
  // console.log("$$$ main analyticsData", analyticsData);
  const [dateFromCalendar, setDateFromCalendar] = useState(new Date());
  useEffect(() => {
    if (dateFromCalendar?.length == 2) {
      //T23:59:00.000Z
      //console.log("dateFromCalendar",dateFromCalendar,  moment(dateFromCalendar[0]).format("YYYY-MM-DD"))

      setSelectedDateRange({
        ...selectedDateRange,
        startDate:
          moment(dateFromCalendar[0]).format("YYYY-MM-DD") + "T00:00:00.000Z",
        endDate:
          moment(dateFromCalendar[1]).utc().format("YYYY-MM-DD") +
          "T23:59:00.000Z",
      });
    }
  }, [dateFromCalendar]);

  useEffect(() => {
    // console.log(
    //   "Changed in state isDataUpdated",
    //   state.analyticsData.isDataUpdated
    // );
    {
      if (state.analyticsData.isDataUpdated) {
        if (selectedDateRange.startDate && selectedDateRange.endDate) {
          // invokedGetAnalyticsApiDataCall();
        }
      }
    }
  }, [state]);

  useEffect(() => {
    if (
      callBreakDownData &&
      callBreakDownData.totalDndCalls &&
      callBreakDownData.totalDndCalls.length > 0
    ) {
      let dndNumbers = [];
      for (let i = 0; i < callBreakDownData.totalDndCalls.length; i++) {
        let indexData = callBreakDownData.totalDndCalls[i];
        dndNumbers = [...dndNumbers, ...indexData.phone_numbers];
      }
      setDnDNumberData(dndNumbers);
    } else {
      setDnDNumberData([]);
    }
  }, [callBreakDownData]);

  const downloadDndList = () => {
    if (dndNumberData && dndNumberData.length > 0) {
      let updatedArray = [];
      for (let i = 0; i < dndNumberData.length; i++) {
        updatedArray.push({ phoneNumbers: dndNumberData[i].toString() });
      }
      console.log("Updated array", updatedArray);
      downloadExcel({
        fileName: `DnD numbers : ${wfSelection.name}`,
        sheet: "Sheet 1",
        tablePayload: {
          header: ["phoneNumbers"],
          body: updatedArray,
        },
      });
    }
  };

  const getDashboardAccordingToSelection = (selection) => {
    // console.log("wf selection", wfSelection);
    switch (wfSelection.id) {
      case "P0001":
        return (
          <PolicyRenewalDashboard
            selectedDateRange={selectedDateRange}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );

      case "P0002":
        return (
          <HealthInsuranceDashboard
            selectedDateRange={selectedDateRange}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );

      case "P0003":
        return (
          <ZetScenario3Dashboard
            selectedDateRange={selectedDateRange}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );

      case "P0004":
        return (
          <ZetScenario4Dashboard
            selectedDateRange={selectedDateRange}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );

      case "P0005":
        return (
          <ZetScenario5Dashboard
            selectedDateRange={selectedDateRange}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );

      case "P0006":
        return (
          <ZetScenario6Dashboard
            selectedDateRange={selectedDateRange}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );

      case "P0007":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );

      case "P0008":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P0009":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00010":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00011":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00012":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00013":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00014":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00015":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00016":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00017":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00018":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00019":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00020":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00021":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00022":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00023":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00024":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00025":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00026":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00027":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );

      case "P00028":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );

      case "P00029":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00030":
        return (
          <ZetScenario7Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
      case "P00031":
        return (
          <ZetScenario32Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
            modalAllcallBreakdownData={modalAllcallBreakdownData}
            setModalCallBreakdownData={setModalCallBreakdownData}
          />
        );
      case "P00032":
        return (
          <ZetScenario32Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
            modalAllcallBreakdownData={modalAllcallBreakdownData}
            setModalCallBreakdownData={setModalCallBreakdownData}
          />
        );
      case "P00033":
        return (
          <ZetScenario32Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
            modalAllcallBreakdownData={modalAllcallBreakdownData}
            setModalCallBreakdownData={setModalCallBreakdownData}
          />
        );
      case "P00034":
        return (
          <ZetScenario32Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
            modalAllcallBreakdownData={modalAllcallBreakdownData}
            setModalCallBreakdownData={setModalCallBreakdownData}
          />
        );
      case "P00035":
        return (
          <ZetScenario32Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
            modalAllcallBreakdownData={modalAllcallBreakdownData}
            setModalCallBreakdownData={setModalCallBreakdownData}
          />
        );
      case "P00036":
        return (
          <ZetScenario32Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
            modalAllcallBreakdownData={modalAllcallBreakdownData}
            setModalCallBreakdownData={setModalCallBreakdownData}
          />
        );
      case "Zet":
        return (
          <ZetScenario32Dashboard
            selectedDateRange={selectedDateRange}
            workFlowData={wfSelection}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
            modalAllcallBreakdownData={modalAllcallBreakdownData}
            setModalCallBreakdownData={setModalCallBreakdownData}
          />
        );
      default:
        return (
          <PolicyRenewalDashboard
            selectedDateRange={selectedDateRange}
            dndNumberData={dndNumberData}
            downloadDndList={downloadDndList}
          />
        );
    }
  };

  const selectWorkflow = (wfId) => {
    let wfItem = wfNameAndIdmapping.filter((item) => {
      return item.id === wfId;
    });
    if (wfItem.length > 0) {
      setWfSelection(wfItem[0]);
    }
  };

  return (
    <div className="analyticsDashboard">
      <HStack m="0 10px 10px 0" className="sbscoHeadingRow">
        <Box w="100%">
          <Heading as="h4" size="md" noOfLines={1}>
            {/* {getHeaderTitle()} */}
            Customer call analytics
          </Heading>
        </Box>
        <div className="sbscoHeadingRight">
          <Box>
            {/* <Button
              // onClick={() => setModalCallBreakdownData(true)}
              bg="#b48ee8"
              color="white"
              _hover={{ bg: "#9f74db" }}
              borderRadius="md"
              fontSize="sm"
              fontWeight="semibold"
              px={4}
              mr={3}
              h="34px"
              boxShadow="sm"
            >
              Check Call Info
            </Button> */}
          </Box>

          <Box className="sbscoBtnGroup niclBtnGroupLeft">
            <Button
              onClick={() => {
                getTodaysData();
              }}
              size="sm"
              colorScheme={selectedButton.isToday ? "blue" : "gray"}
              variant={selectedButton.isToday ? "solid" : "outline"}
              border="1px"
            >
              Today
            </Button>
            <Button
              onClick={() => {
                getSevenDaysData();
              }}
              size="sm"
              colorScheme={selectedButton.is7days ? "blue" : "gray"}
              variant={selectedButton.is7days ? "solid" : "outline"}
              border="1px"
            >
              7 Days
            </Button>
            <Button
              onClick={() => {
                getThirtyDaysData();
              }}
              size="sm"
              colorScheme={selectedButton.is30Days ? "blue" : "gray"}
              variant={selectedButton.is30Days ? "solid" : "outline"}
              border="1px"
            >
              30 Days
            </Button>
          </Box>
          <Box className="niclBtnGroupRight">
            <VStack className="sbscoBtn">
              <RangePicker
                showTime={{ format: "HH:mm" }}
                format="YYYY-MM-DD HH:mm"
                onChange={onRangeChange}
                placeholder={["Start Date & Time", "End Date & Time"]}
                style={{
                  height: "40px",
                  borderRadius: "8px",
                  border: "1px solid #cbd5e0",
                  boxShadow:
                    "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                  width: "380px",
                  padding: "4px 12px",
                }}
              />
            </VStack>
          </Box>
        </div>
      </HStack>
      {/* <Heading as="h6" size="xs" m="12px">
            Select workflow
          </Heading> */}
      <HStack className="analyticsWorkflowcard">
        <Box
          className="dbBlock"
          w="42%"
          h="150px"
          bg="white"
          style={{
            marginTop: "1em",
            marginBottom: "1em",
            width: "40%",
            backgroundColor: "white",
          }}
        >
          <Heading as="h6" size="xs" m="12px">
            Select workflow
          </Heading>
          <div className="cardSelectBlock">
            <Select
              onChange={(e) => {
                // updateSelectedWorkFlowDetails(e.target.value);
                // setWfSelection(e.target.value);
                selectWorkflow(e.target.value);
              }}
              style={{}}
            >
              {wfNameAndIdmapping.map((item, id) => {
                return (
                  <option
                    onClick={(e) => {
                      console.log("Item selected", item);
                    }}
                    value={item.id}
                  >
                    {item.name}
                  </option>
                );
              })}
            </Select>
          </div>
        </Box>
      </HStack>

      {getDashboardAccordingToSelection()}

      {/* {getDashBoardPiChart()} */}
    </div>
  );
}
